export const SELECTED_COLOR = '#08D3AC'
export const ORIGINAL_COLOR = '#303846'